import { ThemeInterface } from "../../../../styles/theme";
export const styles = (theme: ThemeInterface) => ({
	error: {},
	checkboxLabel: {
		fontSize: "14px",
	},
});
export default styles;
